import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Eyebrow from "../../../../elements/Eyebrow";
import getClassNameFactory from "../../../../utilities/classNames";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";
import DocumentIcon from "@dcl/icons/esm/ui/document";
import DownloadIcon from "@dcl/icons/esm/ui/download";
import SmallRightIcon from "@dcl/icons/esm/ui/small-right";
var iconColors = ["gray", "orange"];
var iconTypes = ["arrowRight", "document", "download", "smallRight"];
var sizes = ["small", "large"];

var ListOfLinksBlockLink = function ListOfLinksBlockLink(_ref) {
  var _classNames;

  var children = _ref.children,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      iconColor = _ref.iconColor,
      iconType = _ref.iconType,
      href = _ref.href,
      newWindow = _ref.newWindow,
      size = _ref.size;
  var getClassName = getClassNameFactory(ListOfLinksBlockLink.displayName);
  var linkAttributes = {
    href: href
  };

  if (newWindow) {
    linkAttributes.target = "_blank";
    linkAttributes.rel = "noopener";
  }

  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(iconColor, "Icon"), true), _defineProperty(_classNames, size, true), _classNames))
    })
  }, /*#__PURE__*/React.createElement("a", _extends({
    className: getClassName({
      descendantName: "link"
    })
  }, linkAttributes), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, eyebrow && eyebrow.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "eyebrow"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrow
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "text"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, children), description && description.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "description"
    })
  }, description) : null), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, iconType === "arrowRight" && /*#__PURE__*/React.createElement(ArrowRightIcon, null) || iconType === "document" && /*#__PURE__*/React.createElement(DocumentIcon, null) || iconType === "download" && /*#__PURE__*/React.createElement(DownloadIcon, null) || iconType === "smallRight" && /*#__PURE__*/React.createElement(SmallRightIcon, null))))));
};

ListOfLinksBlockLink.displayName = "ListOfLinks.BlockLink";
/* eslint-disable max-len */

ListOfLinksBlockLink.propTypes = {
  /**
   * Title text.
   */
  children: PropTypes.string.isRequired,

  /**
   * Description text.
   */
  description: PropTypes.string,

  /**
   * Eyebrow text for the title. Not visible on small BlockLinks.
   */
  eyebrow: PropTypes.string,

  /**
   * URL.
   */
  href: PropTypes.string.isRequired,

  /**
   * The color for the icon, renders to the right hand side.
   */
  iconColor: PropTypes.oneOf(iconColors),

  /**
   * Icon type, renders to the right hand side.
   */
  iconType: PropTypes.oneOf(iconTypes),

  /**
   * Open link in new tab/window.
   */
  newWindow: PropTypes.bool,

  /**
   * Size of the BlockLink. Small will hide the eyebrow.
   */
  size: PropTypes.oneOf(sizes)
};
/* eslint-enable max-len */

ListOfLinksBlockLink.defaultProps = {
  iconColor: "gray",
  iconType: "arrowRight",
  newWindow: false,
  size: "large"
};
ListOfLinksBlockLink.iconColors = iconColors;
ListOfLinksBlockLink.iconTypes = iconTypes;
ListOfLinksBlockLink.sizes = sizes;
export default ListOfLinksBlockLink;